import React from "react";

const Equipment = ({ size = 50, color }: any) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 358.52 383.22"
      width={size}
      height={size}
    >
      <path
        fill={color}
        d="M150.19,489.25c-7.43-3.08-10.38-8.72-9.73-16.58.24-3-.05-6,.06-9,.27-7.39,5.52-12.62,12.93-12.69,11.23-.09,22.46,0,33.69,0h4.2a21.71,21.71,0,0,0,.33-2.46q0-22.78,0-45.58a12.9,12.9,0,0,0-.49-2.49l0,.06,13.36-.93V451h12.71c8.37,0,16.74-.05,25.11,0,8.09.06,13.27,5.22,13.48,13.34.08,2.74-.16,5.5.05,8.22.61,7.81-2.22,13.55-9.64,16.69Zm3.3-13h89.23V464H153.49Z"
        transform="translate(-31.73 -106.03)"
      />
      <path
        fill={color}
        d="M288,310.51h12.33c.07,1.54.19,3,.19,4.41q0,25.08,0,50.15a17.85,17.85,0,0,0,.36,4.45,6.26,6.26,0,0,0,12.07.07,19.43,19.43,0,0,0,.38-4.83q0-24.69,0-49.39v-4.73h76.5v114.5H313.63c-.09-1.27-.25-2.58-.26-3.89q0-12.35,0-24.69a31.53,31.53,0,0,0-.1-3.37c-.42-3.73-2.91-6.08-6.36-6.06s-6.23,2.51-6.3,6.49c-.17,9-.07,18-.09,26.95v4.63H288Z"
        transform="translate(-31.73 -106.03)"
      />
      <path
        fill={color}
        d="M51,291.43h57.28c.08,1.4.22,2.71.22,4,0,50.12-.17,100.25.11,150.37.1,18.36-13.55,30.47-28.58,30.65A28.54,28.54,0,0,1,51.11,449c-.27-8.22-.11-16.46-.11-24.68V291.43ZM76.59,439.61h-.06c0-2.74.19-5.5,0-8.22a6.18,6.18,0,0,0-6.5-5.9,6,6,0,0,0-6.12,6.2c-.13,5.86-.23,11.73.06,17.58.38,7.74,7.4,14.26,15.1,14.44,3.54.08,6.19-1.89,6.87-5.1S85,451.82,82,451.52c-5.65-.57-5.69-4.06-5.39-8.16C76.67,442.11,76.59,440.86,76.59,439.61Z"
        transform="translate(-31.73 -106.03)"
      />
      <path
        fill={color}
        d="M108.25,278.2H51.3V157c2,0,3.91.07,5.86,0,3.87-.18,6.55-2.78,6.58-6.26a6.45,6.45,0,0,0-6.5-6.41c-4-.18-8,0-12-.07-7.94-.1-13.62-5.53-13.52-12.89.1-7.14,5.82-12.58,13.5-12.6q34.47-.08,69,0c7.92,0,13.59,5.53,13.52,12.92s-5.61,12.51-13.43,12.56c-9.37.06-18.74,0-28.11,0-1,0-2-.05-3,0-4.09.3-6.67,3-6.52,6.69s2.65,6,6.71,6c6.87.09,13.75,0,20.62,0h4.28Z"
        transform="translate(-31.73 -106.03)"
      />
      <path
        fill={color}
        d="M153.46,310.14c-.06-1.23-.17-2.32-.17-3.41q0-29,0-58c0-6.45,2.15-8.67,8.44-8.67q36.54,0,73.08,0c5.59,0,8.14,2.22,8.15,7.45.08,20.32,0,40.64,0,61a12.73,12.73,0,0,1-.23,1.64Z"
        transform="translate(-31.73 -106.03)"
      />
      <path
        fill={color}
        d="M306.84,227.45H370.9c.24,1.78.41,3.49.7,5.18,1.4,8.08,4.11,15.73,9,22.32a46.72,46.72,0,0,1,9.55,31.14c-.17,3.71,0,7.43,0,11.33H287.89c-.39-13-1.7-26.25,6.31-37.76C301,250,306,239.74,306.84,227.45Z"
        transform="translate(-31.73 -106.03)"
      />
      <path
        fill={color}
        d="M288,438.44H390c0,9.21.41,18.29-.14,27.31-.37,6.11-5.86,10.65-12.09,10.68q-38.78.18-77.54,0c-6.32,0-11.71-4.44-12.08-10.6C287.59,456.81,288,447.72,288,438.44Z"
        transform="translate(-31.73 -106.03)"
      />
      <path
        fill={color}
        d="M191.69,195.43V116.88c0-.87,0-1.75,0-2.62.07-5.29,2.48-8.31,6.56-8.23s6.24,2.93,6.25,8.11q0,38.16,0,76.32v5c2.84,0,5.31-.1,7.76,0,4,.22,6.22,2.15,6.81,6.12,1.24,8.37,2.37,16.77,3.59,25.46H173.58c1.24-8.69,2.4-17.2,3.67-25.7.57-3.74,2.74-5.65,6.62-5.87C186.32,195.32,188.79,195.43,191.69,195.43Z"
        transform="translate(-31.73 -106.03)"
      />
      <path
        fill={color}
        d="M243,349v27.92c0,5.24.08,10.48,0,15.71-.1,4.35-2.17,7-6.1,7.1-10.6.2-21.19.07-32.07.07V349Z"
        transform="translate(-31.73 -106.03)"
      />
      <path
        fill={color}
        d="M191.17,400.45a27.88,27.88,0,0,0-3.92-.58c-8.62-.05-17.23,0-25.84,0-5.9,0-8.11-2.3-8.12-8.21q0-19.8,0-39.61c0-1,.12-1.94.2-3.12h37.94c.1,1.18.24,2.15.25,3.11q0,22.42,0,44.85a24.5,24.5,0,0,1-.54,3.66Z"
        transform="translate(-31.73 -106.03)"
      />
      <path
        fill={color}
        d="M383.68,214.39H371.11c-.81-5,1.58-12.36-6.56-12.35s-6.1,7.18-6.61,12.33H345.26c0-2.08.09-4.15,0-6.22-.2-3.68-2.69-6.2-6.11-6.31a6.37,6.37,0,0,0-6.55,5.91c-.2,2.09,0,4.21,0,6.56H319.9c-.68-4.94,1.53-12.25-6.52-12.26s-6.13,7.12-6.52,12.31H294.5c0-5.49-.56-11.1.17-16.54.7-5.25,5.75-8.73,11.14-8.74q33.19-.08,66.37,0a11.51,11.51,0,0,1,11.48,11.06c0,.74,0,1.49,0,2.24Z"
        transform="translate(-31.73 -106.03)"
      />
      <path
        fill={color}
        d="M242.78,335.76H153.55V323.35h89.23Z"
        transform="translate(-31.73 -106.03)"
      />
    </svg>
  );
};

export default Equipment;
